var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_vm.report.vehicleId && _vm.vehicle ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("common.nouns.vehicle")) + " "), _c('v-spacer'), _vm.report.customerName ? _c('v-tooltip', {
    attrs: {
      "bottom": "",
      "nudge-right": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on;
        return [_c('m-icon-button', _vm._g({
          attrs: {
            "icon": "mdi-open-in-new"
          },
          on: {
            "click": _vm.goToDetail
          }
        }, on))];
      }
    }], null, false, 1666720228)
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("common.nouns.details")))])]) : _vm._e(), _vm.report.customerName ? _c('v-tooltip', {
    attrs: {
      "bottom": "",
      "nudge-right": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var on = _ref2.on;
        return [_c('m-icon-button', _vm._g({
          staticClass: "ml-1",
          attrs: {
            "icon": "mdi-trash-can"
          },
          on: {
            "click": _vm.removeVehicle
          }
        }, on))];
      }
    }], null, false, 4107961271)
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("common.verbs.delete")))])]) : _vm._e()], 1), _c('v-card-text', [_c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "md": "4"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('objects.vehicle.displayName'),
      "readonly": _vm.readonly,
      "hide-details": ""
    },
    model: {
      value: _vm.vehicle.displayName,
      callback: function callback($$v) {
        _vm.$set(_vm.vehicle, "displayName", $$v);
      },
      expression: "vehicle.displayName"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "4"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('objects.vehicle.numberplate'),
      "readonly": _vm.readonly,
      "hide-details": ""
    },
    model: {
      value: _vm.vehicle.numberplate,
      callback: function callback($$v) {
        _vm.$set(_vm.vehicle, "numberplate", $$v);
      },
      expression: "vehicle.numberplate"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "4"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('objects.vehicle.identificationnumber'),
      "readonly": _vm.readonly,
      "hide-details": ""
    },
    model: {
      value: _vm.vehicle.identificationnumber,
      callback: function callback($$v) {
        _vm.$set(_vm.vehicle, "identificationnumber", $$v);
      },
      expression: "vehicle.identificationnumber"
    }
  })], 1), _vm.vehicle.registration ? _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "4"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('objects.vehicle.registration.manufacturerName'),
      "readonly": _vm.readonly,
      "hide-details": ""
    },
    model: {
      value: _vm.vehicle.registration.manufacturerName,
      callback: function callback($$v) {
        _vm.$set(_vm.vehicle.registration, "manufacturerName", $$v);
      },
      expression: "vehicle.registration.manufacturerName"
    }
  })], 1) : _vm._e(), _vm.vehicle.registration ? _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "4"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('objects.vehicle.registration.manufacturerDescription'),
      "readonly": _vm.readonly,
      "hide-details": ""
    },
    model: {
      value: _vm.vehicle.registration.manufacturerDescription,
      callback: function callback($$v) {
        _vm.$set(_vm.vehicle.registration, "manufacturerDescription", $$v);
      },
      expression: "vehicle.registration.manufacturerDescription"
    }
  })], 1) : _vm._e(), _vm.vehicle.registration ? _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "4"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('objects.vehicle.registration.manufacturerType'),
      "readonly": _vm.readonly,
      "hide-details": ""
    },
    model: {
      value: _vm.vehicle.registration.manufacturerType,
      callback: function callback($$v) {
        _vm.$set(_vm.vehicle.registration, "manufacturerType", $$v);
      },
      expression: "vehicle.registration.manufacturerType"
    }
  })], 1) : _vm._e(), _vm.vehicle.registration ? _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "4"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('objects.vehicle.registration.initialRegistrationDate'),
      "readonly": _vm.readonly,
      "hide-details": ""
    },
    model: {
      value: _vm.vehicle.registration.initialRegistrationDate,
      callback: function callback($$v) {
        _vm.$set(_vm.vehicle.registration, "initialRegistrationDate", $$v);
      },
      expression: "vehicle.registration.initialRegistrationDate"
    }
  })], 1) : _vm._e(), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "4"
    }
  }, [_c('m-select', {
    attrs: {
      "label": _vm.$t('objects.vehicle.ownership'),
      "readonly": _vm.readonly,
      "items": _vm.ownershipItems,
      "append-icon": _vm.readonly ? '' : undefined,
      "hide-details": ""
    },
    model: {
      value: _vm.vehicle.ownership,
      callback: function callback($$v) {
        _vm.$set(_vm.vehicle, "ownership", $$v);
      },
      expression: "vehicle.ownership"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "4"
    }
  }, [_c('m-select', {
    attrs: {
      "label": _vm.$t('objects.vehicle.state'),
      "readonly": _vm.readonly,
      "items": _vm.vehicleStatusItems,
      "append-icon": _vm.readonly ? '' : undefined,
      "hide-details": ""
    },
    model: {
      value: _vm.vehicle.state,
      callback: function callback($$v) {
        _vm.$set(_vm.vehicle, "state", $$v);
      },
      expression: "vehicle.state"
    }
  })], 1), _c('Can', {
    attrs: {
      "I": _vm.ActionEnum.READ,
      "a": _vm.ResourceEnum.FLEET,
      "field": _vm.vehicle.partnerId
    }
  }, [_vm.vehicle.fleet ? _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "4"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('objects.vehicle.groupId'),
      "readonly": _vm.readonly,
      "append-icon": "mdi-open-in-new",
      "hide-details": ""
    },
    on: {
      "click:append": _vm.goToFleet
    },
    model: {
      value: _vm.vehicle.fleet.title,
      callback: function callback($$v) {
        _vm.$set(_vm.vehicle.fleet, "title", $$v);
      },
      expression: "vehicle.fleet.title"
    }
  })], 1) : _vm._e()], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": _vm.$t('objects.vehicle.note'),
      "readonly": _vm.readonly,
      "hide-details": ""
    },
    model: {
      value: _vm.vehicle.note,
      callback: function callback($$v) {
        _vm.$set(_vm.vehicle, "note", $$v);
      },
      expression: "vehicle.note"
    }
  })], 1)], 1), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('m-select', {
    attrs: {
      "items": [true, false],
      "readonly": _vm.readonly,
      "label": _vm.$t('components.fleet.FleetVehicleDetailContractInputs.hasRoadsideAssistance'),
      "append-icon": _vm.readonly ? '' : undefined,
      "hide-details": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c('v-chip', {
          attrs: {
            "small": ""
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("report.accidentDetails.location.".concat(item))) + " ")])];
      }
    }, {
      key: "item",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_vm._v(" " + _vm._s(_vm.$t("report.accidentDetails.location.".concat(item))) + " ")];
      }
    }], null, false, 687633713),
    model: {
      value: _vm.vehicle.hasRoadsideAssistance,
      callback: function callback($$v) {
        _vm.$set(_vm.vehicle, "hasRoadsideAssistance", $$v);
      },
      expression: "vehicle.hasRoadsideAssistance"
    }
  })], 1)], 1)], 1)], 1)], 1) : !_vm.report.vehicleId ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('div', {
    staticClass: "mx-auto d-flex justify-center align-center"
  }, [_vm.loadingVehicleSuggestion ? _c('v-skeleton-loader', {
    staticStyle: {
      "min-width": "450px"
    },
    attrs: {
      "type": "card-avatar"
    }
  }) : _c('m-no-content', {
    attrs: {
      "icon": "mdi-car",
      "text": _vm.$t('timeLine.VehicleTimeLineElement.notReferenced')
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function fn() {
        return [_c('div', {
          staticClass: "d-flex flex-column flex-sm-row"
        }, [_c('v-btn', {
          staticClass: "mx-2 px-4",
          attrs: {
            "loading": _vm.loadingUpdate,
            "outlined": ""
          },
          on: {
            "click": function click($event) {
              _vm.isAssociatedDialogOpen = true;
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("mdi-link-variant")]), _vm._v(" " + _vm._s(_vm.$t("timeLine.VehicleTimeLineElement.chooseVehicle")) + " ")], 1), _c('Can', {
          attrs: {
            "I": _vm.ActionEnum.CREATE,
            "a": _vm.ResourceEnum.VEHICLE,
            "field": _vm.report.partnerId
          }
        }, [_c('v-btn', {
          staticClass: "mx-2 px-4",
          attrs: {
            "elevation": "0",
            "loading": _vm.loadingUpdate
          },
          on: {
            "click": _vm.createNewVehicle
          }
        }, [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("mdi-plus")]), _vm._v(" " + _vm._s(_vm.$t("timeLine.VehicleTimeLineElement.createNewVehicle")) + " ")], 1)], 1)], 1)];
      },
      proxy: true
    }])
  })], 1), _c('confirm-action-dialog', {
    attrs: {
      "title": _vm.$t('timeLine.VehicleTimeLineElement.chooseVehicle'),
      "subtitle": _vm.$t('components.partner.PartnerReportDetail.PartnerReportUpdateReportDialog.changeVehicleHint'),
      "isDialogActive": _vm.isAssociatedDialogOpen,
      "rightDisabled": !_vm.isAssociatedValid,
      "rightLoading": _vm.loadingUpdate,
      "hideLeft": true
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isAssociatedDialogOpen = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isAssociatedDialogOpen = $event;
      },
      "close": function close($event) {
        _vm.isAssociatedDialogOpen = false;
      },
      "rightClick": _vm.addVehicle
    }
  }, [_vm.vehicleSuggestions.length > 0 && !_vm.isSelected ? _c('v-subheader', [_vm._v(" " + _vm._s(_vm.$t("components.FilterCardPagination.suggestions")) + " "), _c('v-spacer'), _c('a-eicon', {
    attrs: {
      "noColor": true
    }
  })], 1) : _vm._e(), !_vm.isSelected ? _c('v-list', [_c('v-list-item-group', {
    model: {
      value: _vm.selectedVehicleIndex,
      callback: function callback($$v) {
        _vm.selectedVehicleIndex = $$v;
      },
      expression: "selectedVehicleIndex"
    }
  }, _vm._l(_vm.vehicleSuggestions, function (vehicle, i) {
    return _c('v-list-item', {
      key: 'vehicle' + i,
      scopedSlots: _vm._u([{
        key: "default",
        fn: function fn(_ref5) {
          var active = _ref5.active;
          return [_c('v-list-item-action', [_c('v-checkbox', {
            attrs: {
              "input-value": active
            }
          })], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(vehicle.displayName) + " (" + _vm._s(vehicle.numberplate) + ") ")]), _c('v-list-item-subtitle', [_vm._v(" " + _vm._s(vehicle.identificationnumber) + " ")])], 1), _c('v-list-item-action', [_c('v-btn', {
            attrs: {
              "elevation": "0",
              "icon": ""
            },
            on: {
              "click": function click($event) {
                $event.stopPropagation();
                return _vm.goToVehicle(vehicle);
              }
            }
          }, [_c('v-icon', [_vm._v("mdi-open-in-new")])], 1)], 1)];
        }
      }], null, true)
    });
  }), 1)], 1) : _vm._e(), _vm.vehicleSuggestions.length > 0 && !_vm.isSelected ? _c('p', {
    staticClass: "py-4"
  }, [_vm._v(" " + _vm._s(_vm.$t("timeLine.VehicleTimeLineElement.missingSuggestion")) + " ")]) : _vm._e(), _c('vehicle-api-selection', {
    ref: "vehicle-api-selection",
    staticClass: "mb-n6",
    attrs: {
      "clearable": true
    },
    on: {
      "change": _vm.select
    }
  })], 1)], 1) : _vm._e(), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "loading": _vm.isLocationLoading
    }
  }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("report.currentLocation.title")) + " "), _c('v-spacer'), _c('v-tooltip', {
    attrs: {
      "bottom": "",
      "nudge-right": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref6) {
        var on = _ref6.on;
        return [_c('m-icon-button', _vm._g({
          attrs: {
            "icon": !_vm.report.location ? 'mdi-plus' : 'mdi-pencil-outline',
            "loading": _vm.isLocationLoading
          },
          on: {
            "click": _vm.editLocation
          }
        }, on))];
      }
    }])
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("common.verbs.edit")))])]), _vm.report.location ? _c('v-tooltip', {
    attrs: {
      "bottom": "",
      "nudge-right": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref7) {
        var on = _ref7.on;
        return [_c('m-icon-button', _vm._g({
          staticClass: "ml-1",
          attrs: {
            "icon": "mdi-trash-can",
            "loading": _vm.isLocationLoading
          },
          on: {
            "click": _vm.removeLocation
          }
        }, on))];
      }
    }], null, false, 3347344867)
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("common.verbs.delete")))])]) : _vm._e()], 1), _vm.report.location ? _c('v-card-text', [_c('partner-report-map-address', {
    model: {
      value: _vm.report.location,
      callback: function callback($$v) {
        _vm.$set(_vm.report, "location", $$v);
      },
      expression: "report.location"
    }
  })], 1) : _c('v-card-text', [_c('m-no-content', {
    attrs: {
      "icon": "mdi-map-marker-circle",
      "text": _vm.$t('report.currentLocation.description')
    }
  })], 1)], 1), _c('confirm-action-dialog', {
    attrs: {
      "title": _vm.$t('report.currentLocation.title'),
      "isDialogActive": _vm.isLocationDialogOpen,
      "rightDisabled": !_vm.isLocationValid,
      "loading": _vm.isLocationLoading,
      "hideLeft": true
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isLocationDialogOpen = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isLocationDialogOpen = $event;
      },
      "rightClick": _vm.addLocation
    }
  }, [_vm.location ? _c('v-form', {
    model: {
      value: _vm.isLocationValid,
      callback: function callback($$v) {
        _vm.isLocationValid = $$v;
      },
      expression: "isLocationValid"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.address.street'),
      "outlined": "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.location.street,
      callback: function callback($$v) {
        _vm.$set(_vm.location, "street", $$v);
      },
      expression: "location.street"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.address.zip'),
      "outlined": "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.location.zip,
      callback: function callback($$v) {
        _vm.$set(_vm.location, "zip", $$v);
      },
      expression: "location.zip"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.address.city'),
      "outlined": "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.location.city,
      callback: function callback($$v) {
        _vm.$set(_vm.location, "city", $$v);
      },
      expression: "location.city"
    }
  })], 1), _vm.location ? _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('geo-finder-field', {
    attrs: {
      "type": "lat",
      "value": _vm.location.geo.lat,
      "address": _vm.location,
      "label": _vm.$t('components.partner.PartnerReportDetail.PartnerReportUpdateReportDialog.accidentDetails.lat') + ' *',
      "data-test-geo-lat": ""
    },
    on: {
      "update:value": function updateValue($event) {
        return _vm.$set(_vm.location.geo, "lat", $event);
      },
      "update:address": function updateAddress($event) {
        _vm.location = $event;
      }
    }
  })], 1) : _vm._e(), _vm.location ? _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('geo-finder-field', {
    attrs: {
      "type": "lng",
      "value": _vm.location.geo.lng,
      "address": _vm.location,
      "label": _vm.$t('components.partner.PartnerReportDetail.PartnerReportUpdateReportDialog.accidentDetails.lng') + ' *',
      "data-test-geo-lng": ""
    },
    on: {
      "update:value": function updateValue($event) {
        return _vm.$set(_vm.location.geo, "lng", $event);
      },
      "update:address": function updateAddress($event) {
        _vm.location = $event;
      }
    }
  })], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)], 1), _vm.report.fleetId ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("common.nouns.documents")) + " ")])], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('tab-layout', {
    attrs: {
      "tab": _vm.fleetTab,
      "tabs": _vm.fleetTabs
    },
    on: {
      "update:tab": function updateTab($event) {
        _vm.fleetTab = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "tab-0",
      fn: function fn() {
        return [_vm.vehicle ? _c('table-wrapper', {
          attrs: {
            "headers": _vm.headersVehicleContract,
            "allItems": _vm.vehicle.contracts
          },
          on: {
            "click:row": _vm.openVehicleContractSideCard
          },
          scopedSlots: _vm._u([{
            key: "item.contractType",
            fn: function fn(_ref8) {
              var item = _ref8.item;
              return [_c('v-chip', {
                attrs: {
                  "small": "",
                  "color": "info"
                }
              }, [_vm._v(" " + _vm._s(_vm.$t("enums.VehicleContractTypeEnum.".concat(item.contractType))) + " ")])];
            }
          }, {
            key: "item.isActive",
            fn: function fn(_ref9) {
              var item = _ref9.item;
              return [_vm.isActiveVehicleContract(item) ? _c('v-avatar', {
                attrs: {
                  "color": "success",
                  "size": "15px"
                }
              }) : _c('v-avatar', {
                attrs: {
                  "color": "error",
                  "size": "15px"
                }
              })];
            }
          }], null, false, 2673808428)
        }) : _vm._e()];
      },
      proxy: true
    }, {
      key: "tab-1",
      fn: function fn() {
        return [_vm.isFleetLoading ? _c('v-skeleton-loader', {
          attrs: {
            "type": "table"
          }
        }) : _vm.report.fleet ? _c('table-wrapper', {
          attrs: {
            "headers": _vm.headersFleetContract,
            "allItems": _vm.report.fleet.contracts
          },
          on: {
            "click:row": _vm.openFleetContractSideCard
          },
          scopedSlots: _vm._u([{
            key: "item.type",
            fn: function fn(_ref10) {
              var item = _ref10.item;
              return [_c('v-chip', {
                attrs: {
                  "small": "",
                  "color": "info"
                }
              }, [_vm._v(" " + _vm._s(_vm.$t("enums.ContractTypeEnum.".concat(item.type))) + " ")])];
            }
          }, {
            key: "item.isActive",
            fn: function fn(_ref11) {
              var item = _ref11.item;
              return [item.activeContractAtDate(_vm.report.accidentDate) ? _c('v-avatar', {
                attrs: {
                  "color": "success",
                  "size": "15px"
                }
              }) : _c('v-avatar', {
                attrs: {
                  "color": "error",
                  "size": "15px"
                }
              })];
            }
          }], null, false, 270459454)
        }) : _vm._e()];
      },
      proxy: true
    }, {
      key: "tab-2",
      fn: function fn() {
        return [_c('partner-report-vehicle-fleet-document-table', {
          attrs: {
            "report": _vm.report
          }
        })];
      },
      proxy: true
    }], null, false, 825119940)
  }), _vm.vehicle && _vm.vehicleSideCardContract ? _c('vehicle-contract-side-card', {
    attrs: {
      "partnerId": _vm.vehicle.partnerId,
      "vehicle": _vm.vehicle
    },
    on: {
      "close": function close($event) {
        _vm.vehicleSideCardContract = null;
      }
    },
    model: {
      value: _vm.vehicleSideCardContract,
      callback: function callback($$v) {
        _vm.vehicleSideCardContract = $$v;
      },
      expression: "vehicleSideCardContract"
    }
  }) : _vm._e(), _vm.fleetSideCardContract ? _c('contract-side-card', {
    attrs: {
      "value": _vm.fleetSideCardContract
    },
    on: {
      "close": function close($event) {
        _vm.fleetSideCardContract = null;
      }
    }
  }) : _vm._e()], 1)], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }